module.exports = __webpack_public_path__ + "img/logo.91246584.png";